import React from 'react';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';
import { DataContractCard } from './components/DataContractCard/DataContractCard';

export interface AccountManagerAppProps {
  accountId?: string;
}

export const AccountManagerApp: React.FC<AccountManagerAppProps> = ({ accountId }) => {
  useAppLanguage();

  return <DataContractCard accountId={accountId} />;
};
